import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"

const DocumentoFormDocumentosAsociados = ({
  documentosAsociadosMsg,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { colorSelected } = useSelector(newDocumentoSettingsSelector)
  return (
    <div className='row'>
      <div className='col-6'>
        <div className='border-0 card'>
          <div
            style={{ backgroundColor: colorSelected }}
            className='card-header header-blue d-flex align-items-center'
          >
            <span>{t("crear.facturaRec.partnersDocumentLabel")}</span>
          </div>

          <div className='text-left card-body'>
            <p>{documentosAsociadosMsg}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DocumentoFormDocumentosAsociados
